module.exports = __webpack_public_path__ + "static/media/InfraWorks.fbf49a7d.png";